import { render, staticRenderFns } from "./AddPriceList.vue?vue&type=template&id=1bb7d0b8&"
import script from "./AddPriceList.vue?vue&type=script&lang=js&"
export * from "./AddPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports